export function buildTrustPageURL() {
  return '/trust'
}
